import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Error from '../../Components/UiErrorComponents/Error';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { selectUser } from '../../features/auth/selector';
import { useGetQuizzesWithVideoIdQuery } from '../../features/quiz/quizApi';
import { useEdiQuizMarkMutation, useGetQuizMarkWithStudentIdAndVideoIdQuery, useSubmitQuizMutation } from '../../features/quizMark/quizMarkApi';
import QuizzesMainSection from '../Quizzes/QuizzesMainSection';
import SingleQuiz from './SingleQuiz';

const Quiz = () => {
    const navigate = useNavigate()
    const { videoId } = useParams();
    const { user } = useSelector(selectUser)
    const [quizResult, setQuizResult] = useState([])

    const [submitQuiz, { isLoading: isSubmitLoading, isError: isSubmitError, isSuccess: isSubmitSuccess, data: resData }] = useSubmitQuizMutation()

    const [editQuizMark, { isLoading: isEditQuizMarkLoading, isError: isEditQuizMarkError }] = useEdiQuizMarkMutation()

    const { data: quizzes, isLoading, isError, isSuccess } = useGetQuizzesWithVideoIdQuery(videoId)

    const { data: quizMark, isLoading: isQuizMarkLoading, } = useGetQuizMarkWithStudentIdAndVideoIdQuery({ videoId: parseInt(videoId), studentId: parseInt(user.id) })


    useEffect(() => {
        if (!isLoading && !isError && quizzes?.length) {
            // creating initial quiz ans. isCorrect undefined to check user activity  
            // isCorrect will be undefined, false or true 

            let initialQuizResult = []
            quizzes.forEach(element => {
                const singleQuizResult = {
                    quiz_id: element.id,
                    isCorrect: undefined,
                }
                initialQuizResult = [...initialQuizResult, singleQuizResult]

            });
            setQuizResult(initialQuizResult)
        }
    }, [quizzes, isLoading, isError])

    const handleSubmit = () => {
        // get to know is all quiz has answer
        const booleanArrayOfResult = quizResult.map(single => single.isCorrect)

        if (booleanArrayOfResult.includes(undefined)) {
            toast.error("Please ans all the quiz")
            return
        }
        if (user.role === 'admin') {
            toast.error("sorry admin cannot submit quiz")
            return
        }
        const markForSingleQuiz = 5
        const totalSubmittedQuiz = quizMark[0]?.totalMark / markForSingleQuiz;
        const totalQuizzes = quizzes.length;
        if (totalQuizzes > totalSubmittedQuiz) {
            const previousMark = quizMark[0]

            editQuizMark(
                {
                    id: previousMark.id,
                    user,
                    quiz: quizzes[0],
                    quizResult
                }
            )
        }

        // execute safely
        submitQuiz({
            user,
            quiz: quizzes[0],
            quizResult
        })
    }

    useEffect(() => {
        if (isSubmitSuccess) {
            navigate('/leaderboard')
            toast.success(`Quiz Submitted Successfully! You got ${resData.mark} out of ${resData.totalMark}`)
        }
        if (isSubmitError) {
            toast.error("Something went wrong while submitting quiz")
        }
    }, [isSubmitSuccess, isSubmitError])

    const isQuizzesExist = Boolean(quizzes?.length)
    const isQuizAlreadySubmitted = Boolean(quizMark?.length)

    let content = null;
    if (isLoading || isQuizMarkLoading) {
        content = <div>
            <Loading className='center-of-window'></Loading>
        </div>
    }
    else if (isQuizAlreadySubmitted) {
        const markForSingleQuiz = 5
        const totalSubmittedQuiz = quizMark[0].totalMark / markForSingleQuiz;
        const totalQuizzes = quizzes.length;
        if (totalQuizzes > totalSubmittedQuiz) {

            content = <div>
                <h2 className='text-center mt-3 text-xl text-green-500 font-bold'>New Quiz found! Please re-submit Quiz!</h2>

                <QuizzesMainSection quizzes={quizzes} setQuizResult={setQuizResult} handleSubmit={handleSubmit} isSubmitLoading={isSubmitLoading} isEditQuizMarkLoading={isEditQuizMarkLoading}></QuizzesMainSection>
            </div>

        } else {
            content = <div>
                <h2 className='mt-20 text-center text-4xl font-bold text-green-500'>Your Quiz Result:-</h2>
                <div className='text-center mt-5 text-green-500 text-7xl font-bold '>
                    {quizMark?.length ? <h2>

                        {quizMark[0]?.mark}/{quizMark[0]?.totalMark}
                    </h2> : <></>}
                </div>
            </div>
        }
    }
    else if (isQuizzesExist) {

        content = <QuizzesMainSection quizzes={quizzes} setQuizResult={setQuizResult} handleSubmit={handleSubmit} isSubmitLoading={isSubmitLoading} isEditQuizMarkLoading={isEditQuizMarkLoading}></QuizzesMainSection>
    }
    else {
        content = <div className='text-center'>
            <Error error='No quizzes found!'></Error>
        </div>
    }
    return (
        <>
            {content}
        </>
    );
};

export default Quiz;